import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import CatalogObjectReference from '@square/dashboard-items-data/models/invoices/cart/catalog-object-reference';
import { Money } from '@square/dashboard-items-data/models/invoices/cart/surcharge-snapshot';
import { CalculationPhase, InclusionType } from '@square/dashboard-items-data/models/invoices/enums';
import NumberAsString from '@square/dashboard-items-data/models/attrs/number-as-string';
const AdjustmentType = new Enum(['TAX', 'OBSOLETE_SURCHARGE']);
const Type = new Enum(['ITEM', 'PAGE', 'ITEM_IMAGE', 'ITEM_PAGE_MEMBERSHIP', 'MENU_CATEGORY', 'ITEM_VARIATION', 'FEE', 'PLACEHOLDER', 'DISCOUNT', 'ITEM_FEE_MEMBERSHIP', 'ITEM_MODIFIER_LIST', 'ITEM_ITEM_MODIFIER_LIST_MEMBERSHIP', 'ITEM_MODIFIER_OPTION', 'MARKET_ITEM_SETTINGS', 'ADDITIONAL_ITEM_IMAGE', 'PROMO', 'INVENTORY_INFO', 'OBSOLETE_TENDER_FEE', 'DINING_OPTION', 'TAX_RULE', 'CONFIGURATION', 'TICKET_GROUP', 'TICKET_TEMPLATE', 'VOID_REASON', 'MENU', 'TAG', 'FLOOR_PLAN', 'FLOOR_PLAN_TILE', 'FAVORITES_LIST_POSITION', 'MENU_GROUP_MEMBERSHIP', 'SURCHARGE', 'PRICING_RULE', 'PRODUCT_SET', 'TIME_PERIOD', 'SURCHARGE_FEE_MEMBERSHIP', 'OBJECT_IMAGE_MEMBERSHIP']);

// squareup.api.sync.ObjectType
const ObjectType = ProtoBaseModel.extend({
  type: attr(Type)
});

// squareup.api.sync.ObjectId
const ObjectId = ProtoBaseModel.extend({
  id: attr(String),
  type: attr(ObjectType),
  merchanToken: attr(String),
  customerToken: attr(String),
  v3Token: attr(String)
});

// squareup.api.items.Fee
export default ProtoBaseModel.extend({
  adjustmentType: attr(AdjustmentType),
  amount: attr(Money),
  appliesToCustomAmounts: attr(Boolean),
  appliesToProductSet: attr(ObjectId),
  calculationPhase: attr(CalculationPhase),
  catalogObjectReference: attr(CatalogObjectReference),
  enabled: attr(Boolean),
  feeTypeId: attr(String),
  feeTypeName: attr(String),
  id: attr(String),
  inclusionType: attr(InclusionType),
  name: attr(String),
  percentage: attr(NumberAsString),
  v2Id: attr(String)
}).reopenClass({
  createFor(fee) {
    return this.create({
      adjustmentType: fee.get('adjustmentType'),
      appliesToCustomAmounts: fee.get('appliesToCustomAmounts'),
      calculationPhase: fee.get('calculationPhase'),
      catalogObjectReference: CatalogObjectReference.fromCatalogModel(fee),
      enabled: fee.get('enabled'),
      feeTypeId: fee.get('feeTypeId'),
      feeTypeName: fee.get('feeTypeName'),
      id: fee.get('id'),
      inclusionType: fee.get('inclusionType'),
      name: fee.get('name'),
      percentage: fee.get('percentage')
    });
  }
});